import React, { createContext, useContext, useState, useCallback } from 'react';

const RightPanelContext = createContext(null);

export const RightPanelProvider = ({ children }) => {
    const [isRightPanelOpen, setIsRightPanelOpen] = useState(false);

    return (
        <RightPanelContext.Provider value={{ isRightPanelOpen, setIsRightPanelOpen }}>
            {children}
        </RightPanelContext.Provider>
    );
};

export const useRightPanel = () => {
    const context = useContext(RightPanelContext);
    if (!context) {
        throw new Error('useRightPanel must be used within a RightPanelProvider');
    }
    return context;
};
